"use strict";

define(['app', './template.html'], function (app, tmplInput) {
  return app.Marionette.ItemView.extend({
    template: tmplInput,
    ui: {
      wrapper: '.switch',
      toggle_btn: '.js-toggle'
    },
    events: {
      'click @ui.toggle_btn': 'toggleInput'
    },
    toggleButton: function toggleButton(show) {
      this.ui.wrapper.toggleClass('on', show);
    },
    toggleInput: function toggleInput(e) {
      e.preventDefault();
      var previousValue = this.original_input.prop('checked');
      this.original_input.prop('checked', !previousValue).change();
      return false;
    },
    onRender: function onRender() {
      this.toggleButton(this.original_input.prop('checked'));
      this.ui.toggle_btn.attr({
        'data-track-type': 'click',
        'data-element-name': 'Phrases edit mode'
      });
    },
    initialize: function initialize() {
      var _this = this;

      this.$el.after('<div class="switcher"></div>');
      this.original_input = this.$el;
      this.original_input.hide().on('change', function () {
        _this.toggleButton(_this.original_input.prop('checked'));
      });
      this.setElement(this.$el.next('.switcher')[0]);
    }
  });
});